import { Button, ButtonProps } from '@cast/design-system';

type Props = ButtonProps;

export function TourStepButton(props: Props) {
  return (
    <Button
      {...props}
      variant="ghost"
      testId="tour-step-btn"
      sx={{
        backgroundColor: 'indigo.200',
        color: '#fff',
        mt: 4,
        mb: 8,
        width: '100%',
        '&:hover': {
          backgroundColor: 'indigo.300',
          color: '#fff',
          boxShadow: 'none',
        },
      }}
    />
  );
}
